import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionBox: {
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.grey[50],
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
  },
  sectionTitle: {
    fontWeight: 600,
  },
  sectionSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    marginBottom: theme.spacing(2),
  },
  externalBox: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
  },
  confirmButton: {
    whiteSpace: 'nowrap',
  },
  importButton: {
    marginRight: theme.spacing(1),
  },
}))

export default useStyles
